import axios from "axios";
import { Base_URL } from "../url";

export const saveAccountCode = async (accountCodeData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/AccountCodeMaster?UserName=${userName}`,
      accountCodeData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving account code details!";
  }
};